<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_SOCIAL_MEDIA_MANAGERS"
    title="Social Media Managers"
    sub-title=""
    :breadcrumbs="breadcrumbs"
    page-name="Social Media Managers"
    align="left"
    width="fixed"
  >
    <SmartFeed
      :source="useOrgCommunitySocialMediaExpertiseFeedStore"
      default-entity-size="large"
      default-feed-layout="grid"
      load-more-behavior="auto"
      :show-filters="false"
    >
      <template #empty-state>
        <iSpace :height="10" />
        <iColumn gap="large" align="center">
          <iColumn gap="standard" align="center">
            <iSubHeading variant="subtle" font-size="large">
              No social media managers found
            </iSubHeading>
            <iParagraph
              variant="subtle"
              text-align="center"
              :max-width="400"
            >
              There are currently no social media managers available in the community
            </iParagraph>
          </iColumn>
        </iColumn>
      </template>
    </SmartFeed>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  SECTION_COMMUNITY,
  PAGE_SOCIAL_MEDIA_MANAGERS,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import {
  useOrgCommunitySocialMediaExpertiseFeedStore,
} from "SmartFeed/stores/feed/org-community-social-media-expertise-feed-store";

export default {
  name: "SocialMediaManagers",
  components: {
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_SOCIAL_MEDIA_MANAGERS,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
        { url: "/experts", label: "Experts" },
      ];
    },
  },
  methods: { useOrgCommunitySocialMediaExpertiseFeedStore },
};
</script>
